import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getSpendTimeseriesCsv } from 'api/pulse/spendTimeseries'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useSpendTimeseriesDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_spend_timeseries', {
        filters: query,
      })
      const data = await getSpendTimeseriesCsv(query)
      fileDownload(data, 'spend_timeseries.csv')
    },
  })
}
